import React from 'react'
import tw from 'twin.macro'

const Container = tw.div`relative mt-3 mb-1 px-4`

export const NavContainer = ({ children }: { children: React.ReactNode }) => {
  return <Container>{children}</Container>
}
